import React, { useEffect, useState } from "react";
import styles from "./hallContractForm.module.scss";
import { Box, Grid, Typography } from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomRequiredInputLabel,
  CustomTextFeildforFamily,
} from "../common/StyledComponents/StyledFields";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FacilityUsageAgreementForm from "./formOne/facilityUsageAgreementForm";
import FormFive from "./formFive";
import FormTwo from "./formTwo/formTwo";
import FormThree from "./formThree/formThree";
import FacilityUsageAgreementAcknowledgement from "./formFour/formFour";
import FormSix from "./formSix";
import FormSeven from "./formSeven";
import FormEight from "./formEight";
import FormNine from "./formNine";
import constants from "../../config/constants.json";

import { useSearchParams } from "react-router-dom";
import { isNil } from "lodash";

import apiPath from "../../config/apiPaths.json";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../infrastructure/backendService";
import { createContext } from "react";
import toast from "react-hot-toast";
import ErrorPopup from "../common/ErrorPopup";


export const formOneObject = {
  devoteeUsername: "",
  devoteeAddress: "",
  contact: "",
  eventDate: "",
  eventTime: "",
  noOfGuests: "",
  eventHallsTobeUsed: [],
  eventsRooms: "",
  agreementExecutionDay: "",
  agreementExecutionMonth: "",
  agreementExecutionYear: "",
  eventNature: "",
  hallId: 0,
};

export const FormBodyContext = createContext(formOneObject);

const HallContractFormComponent = () => {
  const [searchParam] = useSearchParams();
  const [devoteeAddress, setDevoteeAddress] = useState<string>("");
  const username = searchParam.get("username") || "";
  const numberOfGuests = searchParam.get("numberOfGuests");
  const hallName = searchParam.get("hallName") || "";
  const eventTime = searchParam.get("eventTime") || "";
  const eventDate = searchParam.get("eventDate") || "";
  const hallId = searchParam.get("hallId") || "";
  const eventType = searchParam.get("eventType") || "";
  const duration = searchParam.get("duration") || "";
  const amount = searchParam.get("amount") || "";
  const description = searchParam.get("description") || "";

  const formOneDataObject = {
    devoteeUsername: username || "",
    devoteeAddress: devoteeAddress,
    contact: "",
    eventDate: eventDate || "",
    eventTime: eventTime || "",
    noOfGuests: numberOfGuests || "",
    eventHallsTobeUsed: [],
    eventsRooms: "",
    agreementExecutionDay: "",
    agreementExecutionMonth: "",
    agreementExecutionYear: "",
    eventNature: "",
    hallId: 0,
  };

  const apiResponseBody = {
    onBehalfOfUsername: username?.toUpperCase(),
    hallId: hallId && parseInt(hallId, 10) || 0,
    bookingDate: eventDate || "",
    bookingTime: eventTime || "",
    duration: parseInt(duration) || 0,
    amount: parseInt(amount) || 0,
    description: description || "",
    eventGuestCount: numberOfGuests && parseInt(numberOfGuests, 10) || 0,
    eventNature: eventType || "",
    contractForm: {
      devoteeUsername: username,
      devoteeFullname: "",
      devoteeInitials: "",
      email: "",
      address: "",
      city: "",
      state: "",
      country: "",
      zipcode: "",
      phoneNumber: "",
      alternatePhoneNumber: "",
      eventHallId: [hallId && parseInt(hallId, 10) || 0],
      eventDate: eventDate || "",
      eventDuration: parseInt(duration) || 0,
      eventGuestCount: numberOfGuests && parseInt(numberOfGuests, 10) || 0,
      eventNature: eventType || "",
      eventRequiredRoomsCount: 1,
      agreementExecutionDate: "",
    },
  };

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 9;
  const [formOneData, setFormOneData] = useState({ ...formOneDataObject });
  const [childClick, setChildClick] = useState(null);
  const [reqBody, setReqBody] = useState({...apiResponseBody});
  const [sign, setSign] = useState("");

  useEffect(() => {
    if (!isNil(username)) {
      apiRequest({
        method: "GET",
        endpoint: `${apiPath.getDevoteeDetails}/${username?.toUpperCase()}`,
        includeToken: true,
      })
        .then((res) => {
          console.log(res.data, "first...............");
          setDevoteeAddress(res.data.address);
        })
        .catch((err) => {
          console.log(err);
          toast.custom(
            
            <ErrorPopup
             
              showMessage={catchErrorMessageHandler(err)}
             
              isOpen={false}
           
            />,
           
            {
                duration: constants.TOAST_POPUP_DURATION,
              }
          
          );
        });
    }
  }, []);

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const updateMethod = (newState: any) => {
    setFormOneData(newState);
  };



  // Function to go to the previous form
  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const formHeader = (): JSX.Element => {
    return (
      <Box className={styles.Header}>
        <div>
          <img src="/images/TempleOldLogo.png" className={styles.HeaderImage} />
          <Typography className={styles.TempleNameData}>
            Shiva -Vishnu Temple
          </Typography>
        </div>
        <Box className={styles.TempleAddress} sx={{ textAlign: "right" }}>
          <Typography className={styles.TempleAddressData}>
            <span style={{ fontWeight: "bold", letterSpacing: "1px" }}>
              Hindu Community and Cultural Center
            </span>
            <br />A Registered Non-Profit Organization
            <br />
            Tax ID: 94-2427126, Inc: D08215891232,
            <br /> Arrowhead Ave, Livermore, CA 94551 <br />
            Tel: (925) 449-6255, Fax: (925) 455-0404.
          </Typography>
        </Box>
      </Box>
    );
  };

  // Placeholder component to simulate different form steps
  const FormStepContent = () => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <span className={styles.currentStepStyles}>{currentStep}</span>{" "}
      <span style={{ padding: "5px 10px 5px 10px" }}>/ {totalSteps}</span>
    </div>
  );

  // Conditionally render the form based on the current step
  // const renderFormStep = () => {
  //   switch (currentStep) {
  //     case 1:
  //       return (
  //         <FacilityUsageAgreementForm
  //           updateMethod={updateMethod}
  //           handleNext={handleNext}
  //         />
  //       );
  //     // case 2:
  //     //   return <FormThree />;
  //     // case 3:
  //     //   return <FormTwo />;
  //     // case 4:
  //     //   return <FacilityUsageAgreementAcknowledgement />;
  //     // case 5:
  //     //   return <FormFive />;
  //     // case 6:
  //     //   return <FormSix />;
  //     // case 7:
  //     //   return <FormSeven />;
  //     // case 8:
  //     //   return <FormEight />;
  //     // case 9:
  //     // return <FormNine />;
  //     default:
  //       return (
  //         <FacilityUsageAgreementForm
  //           updateMethod={updateMethod}
  //           handleNext={handleNext}
  //         />
  //       );
  //   }
  // };

  const SignComponent = (): JSX.Element => {
    return (
      <Grid xs={12} sm={3} item className={styles.signInComponent}>
        {CustomRequiredInputLabel("User’s Initial’s", false)}
        <CustomTextFeildforFamily 
          sx={{ width: "200px" }}
          className={styles.textField}
          value={sign}
          onChange={(e)=>{setSign(e.target.value)}}
        />
      </Grid>
    );
  };

  const handleButtons = () => {
    return (
      <div style={{ display: "flex", gap: "1rem" }}>
        <CommonOutlinedButton>Cancel</CommonOutlinedButton>
        <CommonButton>Submit</CommonButton>
      </div>
    );
  };

  const navigationButtons = () => {
    return (
      <div style={{ display: "flex", gap: "10px",marginBottom:"64px" }}>
        <CommonOutlinedButton
          startIcon={<ChevronLeftIcon />}
          onClick={handlePrevious}
          disabled={currentStep === 1}
        >
          Previous
        </CommonOutlinedButton>
        {FormStepContent()}
        <CommonButton
          endIcon={<KeyboardArrowRightIcon />}
          onClick={handleNext}
          disabled={currentStep === totalSteps}
        >
          Next
        </CommonButton>
      </div>
    );
  };

  const formFooter = () => {
    return (
      <Box className={styles.footer}>
        <Box>{SignComponent()}</Box>
        <Box>
          <Typography className={styles.footerMessage}>
            {constants.HALL_FORM_FOOTER_TEXT}
          </Typography>
        </Box>
      </Box>
    );
  };

  const handleUpdatedReqBody = (newState:any) => {
    setReqBody(newState);
  }

  return (
    <div className={styles.formMainContainer}>
      {formHeader()}
      <Box className={styles.userConatiner}>
        <Typography className={styles.rightData}>
          <span className={styles.leftData}>Name : {username} </span>
        </Typography>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography className={styles.rightData}>
            <span className={styles.leftData}>Address :</span> {devoteeAddress}
          </Typography>
          {/* {navigationButtons()} */}
        </div>
      </Box>
      <FormBodyContext.Provider value={formOneData}>
        {/* {renderFormStep()} */}
        <FacilityUsageAgreementForm
          sign={sign}
          updateMethod={updateMethod}
          handleNext={handleNext}
          updatedReqBody={handleUpdatedReqBody}
          reqBody={reqBody}
        />
      </FormBodyContext.Provider>
      {/* {formFooter()} */}
    </div>
  );
};

export default HallContractFormComponent;
